export const clothSizes: { size: string }[] = [
  {
    size: "xs",
  },
  {
    size: "s",
  },
  {
    size: "m",
  },
  {
    size: "l",
  },
]

export const shoeSizes: { size: string }[] = [
  {
    size: "41",
  },
  {
    size: "42",
  },
  {
    size: "43",
  },
  {
    size: "44",
  },
]

export const colors: { color: string }[] = [
  {
    color: "brown",
  },
  {
    color: "gray",
  },
  {
    color: "black",
  },
]
